import { SVGProps } from 'react';

export const DashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='18' height='2' viewBox='0 0 18 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path id='Vector 69' d='M0 1H18' stroke={props.fill || 'white'} strokeWidth='2' />
  </svg>
);
